export default __webpack_public_path__ + "static/media/datepicker-arrow-left.7161cff7.svg";